<template>
  <el-container>
    <div class="t_neiban">
      <div class="t_b1banpic">
        <img src="../assets/image/lianxiwomenbanner.jpg" alt="lianxiwomenbanner.jpg">
      </div>
      <div class="nesc_cont1360 nesc_pos_bot">
        <h2 class="nesc_inban_title animate__animated animate__fadeInDown">{{ $t('lang.channelCooperation') }}</h2>
      </div>
    </div>
    <div class="nesc_cont1360">
      <el-row type="flex" class="row-bg" justify="center" style="flex-wrap: wrap;align-items: center">
        <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <h2 class="nesc_inban_title t">{{ $t('lang.contactUs') }}</h2>
          <div class="mc_i1s1_telbox margin-top margin-bottom">
            <div class="mc_i1s1_dl clearfix">
              {{ $t('lang.address') }}：江苏省无锡市新吴区珠江路50号
            </div>

            <div class="mc_i1s1_dl clearfix">
              {{ $t('lang.phone') }}：400-835-9997
            </div>
            <div class="mc_i1s1_dl clearfix">
              {{ $t('lang.email') }}：nesc01@cnano.com.cn
            </div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
          <div id='mapContainer' style="width:100%;height:500px"></div>
        </el-col>
      </el-row>
    </div>
  </el-container>
</template>

<script>

export default {
  name: 'ChannelCoop',
  components: {},
  data() {
    return {
      center: {lng: 120.378882, lat: 31.511560},
      zoom: 15,
      infoWindow: {
        show: false
      }
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      this.$nextTick(() => {
        //获取dom节点
        var drawContainer = document.getElementById('mapContainer');
        // var center = new window.TMap.LatLng(39.984104, 116.307503);//设置中心点坐标   lat: 23.228237   lng: 113.273747
        //如果是回显的话直接把经纬度传进去就行
        var center = new window.TMap.LatLng(this.center.lat, this.center.lng);
        this.map = new window.TMap.Map(drawContainer, {
          zoom: 18,
          // pitch: 40,
          center: center,
          draggable: true,
          scrollable: true,
        });
        // 初始化marker
        this.marker = new window.TMap.MultiMarker({
          id: 'marker-layer', // 图层id
          map: this.map,
          geometries: [
            {
              "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new window.TMap.LatLng(this.center.lat, this.center.lng),  //点标记坐标位置
              "properties": {}
            }
          ]
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
img {
  vertical-align: middle;
}

.t_neiban {
  position: relative;
}

.t_b1banpic {
  width: 100%;
}

.t_b1banpic img {
  width: 100%;
}

.nesc_pos_bot {
  position: absolute;
  bottom: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important;
}

.nesc_inban_title {
  font-size: 72px;
  line-height: 1.45;
  font-weight: bold;
  font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  color: rgba(87, 87, 87, 0.8);
}

.nesc_inban_title.t {
  color: #333333 !important;
}

.mc_i1s1_dl {
  font-size: 18px;
  line-height: 54px;
  color: #333333;
  font-family: "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif
}

.row-bg {
  padding: 100px 0 75px;
}

.map {
  height: 400px;
}

@media screen and (max-width: 1680px) {
  .nesc_inban_title {
    font-size: 64px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_inban_title {
    font-size: 48px;
  }
  .mc_i1s1_dl {
    font-size: 16px;
  }
}

@media screen and (max-width: 776px) {
  .nesc_inban_title {
    font-size: 28px;
  }
  .mc_i1s1_dl {
    line-height: 24px;
  }
  .row-bg {
    padding: 50px 0 25px;
  }
}

</style>
